import React, { useState, useEffect } from 'react';
import { Departamento } from '@app/api/departamento';
import { Diretoria } from '@app/api/diretoria';
import { Area } from '@app/api/area';
import { updateTap, TapCicloOrcamentarioHasJoinProjeto } from '@app/api/crf/crfTap';
import {
  Widget,
  FormSelect,
  FormSubmitButton,
  FormatText,
  FormInput,
  FormTextArea,
  MasterDetailForm,
  Row,
} from '@digital/ui';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';
import { Collapse, Icon } from 'antd';

interface FormTapProps {
  areas: Area[];
  departamentos: Departamento[];
  diretorias: Diretoria[];
  tapDiretoriaId: string;
  tapDepartamentoId: string;
  tapAreaId: string;
  tapEscopoAnual: string;
  tapId: string;
  tapAno: number;
  initialValues: TapCicloOrcamentarioHasJoinProjeto;
  keyId: string;
}
const { Panel } = Collapse;
const FormTapCicloOrcamentario = (props: FormTapProps) => {
  const { diretorias, areas, departamentos, tapId, tapAno, keyId, initialValues } = props;

  let { tapAreaId, tapDiretoriaId, tapDepartamentoId, tapEscopoAnual } = props;

  const [filteredAreas, setFilteredAreas] = useState<Area[]>([]);
  const [filteredDepartamentos, setFilteredDepartamentos] = useState<Departamento[]>([]);

  const [selectedAreaId, setSelectedAreaId] = useState<string>(tapAreaId);
  const [selectdDiretoriaId, setSelectdDiretoriaId] = useState<string>(tapDiretoriaId);
  const [selectdDepartamentoId, setSelectdDepartamentoId] = useState<string>(tapDepartamentoId);
  const [selectdEscopoAnual, setSelectdEscopoAnual] = useState<string>(tapEscopoAnual);

  useEffect(() => {
    const areasList = areas.filter(a => a.diretoriaId === tapDiretoriaId);

    if (tapAreaId) {
      const departamentosList = departamentos.filter(a => a.areaId === tapAreaId);
      setFilteredDepartamentos(departamentosList);
    } else if (tapDiretoriaId) {
      const newFilteredList = departamentos.filter(d => d.diretoriaId === tapDiretoriaId);
      setFilteredDepartamentos(newFilteredList);
    }

    setFilteredAreas(areasList);

    //if (departamentosList.length > 0) setFilteredDepartamentos(departamentosList);
  }, [areas, departamentos]);

  const handleUpdate = () => {
    const TapjoinProjeto: TapCicloOrcamentarioHasJoinProjeto = {
      tapId: tapId,
      tapAreaId: selectedAreaId,
      tapDiretoriaId: selectdDiretoriaId,
      tapDepartamentoId: selectdDepartamentoId,
      tapEscopoAnual: selectdEscopoAnual,
    };

    updateTap(TapjoinProjeto).then(resp => {
      if (resp.valid) return resp;
    });
  };

  const handleChangeDiretoria = (value: SelectValue) => {
    if (value) {
      tapAreaId = '';
      tapDepartamentoId = '';
      tapDiretoriaId = String(value);
      setSelectedAreaId('');
      setSelectdDepartamentoId('');
      setSelectdDiretoriaId(tapDiretoriaId);

      const areasList = areas.filter(a => a.diretoriaId === value);
      const departamentosList = departamentos.filter(a => a.diretoriaId === value);
      setFilteredAreas(areasList);
      if (departamentosList.length > 0) {
        setFilteredDepartamentos(departamentosList);
      } else {
        setFilteredDepartamentos([]);
      }
    }
  };

  const handleChangeArea = (value: SelectValue) => {

    if (value) {
      tapDepartamentoId = '';
      tapAreaId = String(value);
      setSelectdDepartamentoId('');
      setSelectedAreaId(tapAreaId);

      const isArea = departamentos.filter(a => a.areaId === tapAreaId).length > 0;

      if (isArea) {
        const newFilteredList = departamentos.filter(d => d.areaId === value);
        setFilteredDepartamentos(newFilteredList);
      } else {
        setFilteredDepartamentos([]);
      }
    } else {
      setSelectdDepartamentoId('');
      setSelectedAreaId('');
      const isDiretoria = departamentos.filter(a => a.diretoriaId === tapDiretoriaId).length > 0;
      if (isDiretoria) {
        const newFilteredList = departamentos.filter(d => d.diretoriaId === tapDiretoriaId);
        setFilteredDepartamentos(newFilteredList);
      } else {
        setFilteredDepartamentos([]);
      }
    }
  };

  const handleChangeDepartamento = (value: SelectValue) => {
    if (value) {
      tapDepartamentoId = String(value);
      setSelectdDepartamentoId(tapDepartamentoId);
    } else {
      tapAreaId = '';
      tapDepartamentoId = '';
      setSelectedAreaId('');
      setSelectdDepartamentoId('');

      const isDiretoria = departamentos.filter(a => a.diretoriaId === tapDiretoriaId).length > 0;
      if (isDiretoria) {
        const newFilteredList = departamentos.filter(d => d.diretoriaId === tapDiretoriaId);
        setFilteredDepartamentos(newFilteredList);
      } else {
        setFilteredDepartamentos([]);
      }
    }
  };
  const handleChangeEscopoPluriAnual = (value: any) => {
    if (value) {
      tapEscopoAnual = value.value;
      setSelectdEscopoAnual(tapEscopoAnual);
    }
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header={`${tapAno}`} style={{ border: 0 }}>
          <MasterDetailForm initialValues={initialValues} key={keyId}>
            <Widget
              title=""
              actions={[
                hasPermission(['PROJETO_ABA_TAP_EDITAR']) && (
                  <FormSubmitButton type="primary" onClick={handleUpdate}>
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <Row>
                <FormInput name="tapIdFinplan" label="Id Finplan" span={4} disabled />
              </Row>

              <Row>
                <FormSelect
                  label="Diretoria"
                  name="tapDiretoriaId"
                  options={diretorias && diretorias.map(a => ({ text: a.nome, value: a.id.toString() }))}
                  span={4}
                  optionFilterProp="children"
                  onChange={value => handleChangeDiretoria(value)}
                />
                <FormSelect
                  label="Área"
                  name="tapAreaId"
                  options={filteredAreas && filteredAreas.map(a => ({ text: a.nome, value: a.id.toString() }))}
                  span={4}
                  optionFilterProp="children"
                  onChange={value => handleChangeArea(value)}
                  allowClear
                  value={selectedAreaId}
                />
                <FormSelect
                  label="Departamento"
                  name="tapDepartamentoId"
                  options={
                    filteredDepartamentos && filteredDepartamentos.map(a => ({ text: a.nome, value: a.id.toString() }))
                  }
                  span={4}
                  optionFilterProp="children"
                  onChange={value => handleChangeDepartamento(value)}
                  allowClear
                  value={selectdDepartamentoId}
                />
              </Row>
              <Row>
                <FormTextArea
                  label="Escopo Anual"
                  name="tapEscopoAnual"
                  onInput={value => handleChangeEscopoPluriAnual(value.target)}
                  rows={3}
                  span={12}
                  value={selectdEscopoAnual}
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTapCicloOrcamentario;
